import Home from '../views/home.js';
import { log_page, log_error_js } from './logging.js';
import { currentTimestamp } from "../helpers/time.js";

export default function createRouter(routes, $mount_point, menus) {
    let current_view_instance = null;
    let current_path = null;
    let first_load = true;

    function parseRoute(path) {
        for (const pattern in routes) {
            const regex = new RegExp("^" + pattern.replace(/:[^/]+/g, "([^/]+)") + "$");
            const match = path.match(regex);

            if (match) {
                // Extract placeholders
                const keys = (pattern.match(/:[^/]+/g) || []).map(k => k.substring(1));
                const params = {};

                keys.forEach((key, i) => {
                    params[key] = match[i + 1];
                });

                return { view: routes[pattern], params };
            }
        }

        return null;
    }

    async function loadRoute(path) {
        if (path === current_path) return;

        let result = parseRoute(path);

        if (!result) {
            console.error("No route found for", path);
            result = {
                view: Home,
                params: {}
            }
        }

        const { view, params } = result;

        log_page({
            path: path,
            old_path: current_path,
            date_logged: Math.floor(new Date().getTime() / 1000),
        })

        // Clear previous view
        try {
            if (current_view_instance?.onUnmount) current_view_instance.onUnmount();
            $mount_point.innerHTML = "";
        } catch (e) {
            console.error("Error unmounting previous view. Path: " + current_path);
            log_error_js({
                type: 'error',
                message: 'Error unmounting view: ' + current_path,
                stack: e?.stack || null,
                url: window.location.href,
                timestamp: currentTimestamp(),
            });
        }

        // Create new view instance
        if (typeof view === "function") {
            current_view_instance = await view(params);
        } else {
            current_view_instance = view;
        }

        current_path = path;

        if (first_load) {
            first_load = false;
        } else {
            window.scrollTo(0, 0);
            $mount_point.focus();

            // Close all open menus
            menus.forEach(menu => {
                if (typeof menu === 'object' && typeof menu.close === 'function') {
                    menu.close()
                }
            });
        }

        // Render template
        $mount_point.innerHTML = current_view_instance.template;

        // Mount lifecycle
        try {
            if (current_view_instance.onMount) current_view_instance.onMount(params);
        } catch (e) {
            console.error("Error mounting view. Path: " + path, e);
            log_error_js({
                type: 'error',
                message: 'Error mounting view: ' + path,
                stack: e?.stack || null,
                url: window.location.href,
                timestamp: currentTimestamp(),
            });
        }
    }


    // History API navigation helper
    function navigate(url) {
        const url_object = new URL(url, window.location.origin)
        window.history.pushState({}, "", url);
        loadRoute(url_object.pathname);
    }

    // Intercept clicks on internal links
    function handleLinkClick(e) {
        const anchor = e.target.closest("a");
        if (!anchor) return;

        const href = anchor.getAttribute("href");
        if (!href || /^(https?|mailto|tel|sms|javascript):/i.test(href)) return;

        e.preventDefault();
        navigate(href);
    }

    // Respond to back/forward buttons
    window.addEventListener("popstate", () => {
        loadRoute(window.location.pathname);
    });

    // Set up link interception
    document.addEventListener("click", handleLinkClick);

    // Initial load
    loadRoute(window.location.pathname);

    return { navigate };
}
